export default "__VITE_ASSET__9210f560__"